import { call, put, takeEvery} from "redux-saga/effects";
import {
  GET_MEMO
} from "./actionTypes"

import {

  GetMemoSuccess,
  MemoError
  
} from "./actions"

//Include Both Helper File with needed methods
import {
  GetMemoByObjectGuid
} from "../../helpers/backend_helper/backend_helper"


function* fetchGetMemo({ payload: guid }) {
  try {
    const response = yield call(GetMemoByObjectGuid,guid)
    yield put(GetMemoSuccess(response))
  } catch (error) {
    yield put(MemoError(error))
  }
}

function* MemoManagementSaga() {

    yield takeEvery(GET_MEMO,fetchGetMemo)
}

export default MemoManagementSaga
